import { Segmented } from 'antd'
import type { IssueScope } from './issueFields'

interface IssueScopeToggleProps {
  value: IssueScope
  onChange: (scope: IssueScope) => void
  /** Issue count per scope; undefined while that scope is still loading. */
  counts: Record<IssueScope, number | undefined>
}

const SCOPE_LABELS: Record<IssueScope, string> = {
  all: 'All',
  mine: 'My Issues',
  partner: 'Partner Issues',
}

const SCOPE_ORDER: IssueScope[] = ['all', 'mine', 'partner']

/** Whose issues the section lists: everyone's, ours, or the partner's. */
export function IssueScopeToggle({
  value,
  onChange,
  counts,
}: IssueScopeToggleProps) {
  return (
    <Segmented<IssueScope>
      value={value}
      onChange={onChange}
      // The section stacks its children, which would stretch the control the
      // full width of the column; it should only be as wide as its options.
      style={{ alignSelf: 'flex-start' }}
      options={SCOPE_ORDER.map((scope) => ({
        value: scope,
        label: (
          <span>
            {SCOPE_LABELS[scope]}
            {counts[scope] !== undefined && (
              <span style={{ marginLeft: 6, opacity: 0.6 }}>
                {counts[scope]?.toLocaleString()}
              </span>
            )}
          </span>
        ),
      }))}
    />
  )
}
